<style scoped>
.p0-50 {
  padding: 0 50px;
}
</style>

<template lang="pug">
    .container-fluid
        ul
            li
                div.p0-50
                    app-supplier-details(:supplier='supplier', 
                        @updated='onSupplierUpdated',
                        @created='onSupplierCreated', 
                        ref='supplierDetails')
            li(v-if='!supplier.new')
                div.p0-50
                    app-supplier-accounts(:supplier='completeSupplier')
            //- li(v-if='!isApplicant && !isNew')
            //-     div.p0-50
            //-         app-supplier-shops(:supplier='supplier')
</template>
<script>
/* eslint-disable no-undef */
import AppSupplierDetails from '@/components/app-supplier-details'
import AppSupplierShops from '@/components/app-supplier-shops'
import AppSupplierAccounts from '@/components/app-supplier-accounts'
import axios from 'axios'

export default {
  props: ['supplier'],
  data () {
    return {
      completeSupplier: this.supplier
    }
  },
  mounted () {
    this.$M.Collapsible.init(document.querySelectorAll('.collapsible'))
    axios.get(`${this.$config.API_URL}/suppliers/${this.supplier.code}`, {
      params: {
        includeAccounts: true
      }
    }).then(result => {
      this.$set(this, 'completeSupplier', result.data)
    })
  },
  computed: {
    isApplicant () {
      return this.supplier.status === 'application'
    },
    isNew () {
      if (this.supplier !== null) {
        return this.supplier.new === true
      }
    },
    mutableSupplier () {
      return this.$refs.supplierDetails.mutableSupplier
    }
  },
  methods: {
    onSupplierUpdated (supplier) {
      this.$emit('updated', supplier)
    },
    onSupplierCreated (supplier) {
      this.$emit('created', supplier)
    }
  },
  components: {
    AppSupplierDetails,
    AppSupplierShops,
    AppSupplierAccounts
  }
}
</script>




// WEBPACK FOOTER //
// src/components/app-supplier.vue